module.exports = __webpack_public_path__ + "static/img/ikonaPdf.2558e095.png";